<template>
<tutorial-layout title="Logging" :referenceLinks="referenceLinks" :youtubeLinks="youtubeLinks">
    <p slot="overview">Overview text goes here.</p>

    <v-btn @click="log">LOG</v-btn>


</tutorial-layout>
</template>

<script>
import moment from "moment";
import uiView from "@/_mixins/ui-view-mixin";
import tutorialLayout from "../../components/tutorial-layout";

import {
    ApplicationInsights
} from '@microsoft/applicationinsights-web'

const appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: '513c93f8-a8ae-4594-a41f-6ecf1c71840f'
    }
});

/* ...Other Configuration Options... */

export default {
    name: "VModel",
    mixins: [uiView],
    created() {
      appInsights.loadAppInsights();
    },
    data() {
        return {
            text1: "Example Text",
        };
    },
    components: {
        tutorialLayout
    },
    props: {},
    watch: {},
    computed: {
        referenceLinks() {
            return [];
        },
        youtubeLinks() {
            return [];
        },
    },
    methods: {
        log() {
            appInsights.trackPageView();
        }
    },
};
</script>

<style lang="scss">
</style>
